// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_025a50318d--tooltip---3SJq","arrow_tooltip":"_025a50318d--arrow_tooltip--3prMb","arrow":"_025a50318d--arrow--asGsy","close":"_025a50318d--close--2iFDx"};